<template>
    <!--  活动讯息-->
    <div class="taoist">
        <topBack>{{$t('navName')[5]}}</topBack>
        <barF5></barF5>
        <!-- 展示列表 -->
        <div
            class="content flex-between"
            @click="linkToDetail(item)"
            v-for="(item,index) in contentList"
            :key="index"
        >
            <div class="title oneLine">{{item.news_title}}</div>
            <div class="time">{{item.data}}</div>
        </div>
        <!-- 分页 -->
        <div class="pageBar" id="pageBar">
            <div class="block">
                <el-pagination
                    :pager-count="3"
                    @current-change="handleCurrentChange"
                    background
                    :page-size="page.per_page"
                    layout=" prev, pager, next"
                    :total="page.total"
                    :prev-text="$t('preText')"
                    :next-text="$t('nextText')"
                ></el-pagination>
                
            </div>
        </div>

        <!-- 去除底部button所占的位置 -->
        <!-- <empty></empty> -->
        <!-- 底部button -->
        <!-- <footer>
            <Button>{{$t('firstHome')}}</Button>
        </footer> -->
    </div>
</template>

<script>
import { getTimeBeforeDay } from "../../common/js/common";
import { getCateList, getActivityList } from "../../api/apis";
import topBack from "../../components/topBack.vue";
import barF5 from "../../components/barF5"; //空隙bar
import empty from "../../components/empty";
import Button from "../../components/button"; //返回首頁
export default {
    name: "活动讯息",
    components: {
        topBack,
        empty,
        Button,
        barF5
    },
    props: [],
    data() {
        return {
            page: {
                total: 0,
                per_page: 11,
                current_page: 1,
                last_page: 1
            },
            cateId: "", //获取列表的id
            contentList: [
                // {
                //     news_title: "關於力量的一點體會",
                //     data: "2019-09-19"
                // },
                // {
                //     news_title: "關於力量的一點體會",
                //     data: "2019-09-19"
                // },
                // {
                //     news_title: "關於力量的一點體會",
                //     data: "2019-09-19"
                // }
            ]
        };
    },
    methods: {
        handleCurrentChange(e) {
            this.page.current_page = e;
            this.getInfoList();
        },
        //获取展示数据
        getInfoList() {
            getActivityList(this.cateId, {
                limit: this.page.per_page,
                page: this.page.current_page
            }).then(res => {
                this.page.total = res.total;
                this.page.current_page = res.current_page;
                this.page.last_page = res.last_page;
                // this.contentList = getTimeBeforeDay(res.data, "data");
                this.contentList = res.data;
            });
        },
        linkToDetail(item) {
            this.$router.push({
                path: "articleDetail",
                query: {
                    name: "information",
                    id: item.id,
                    title: this.$t("navName")[5]
                }
            });
        }
    },
    mounted() {
        getCateList().then(res => {
            this.cateId = res[3][0].id;
            this.getInfoList();
        });
    }
};
</script>
<style>


</style>
<style scoped>
.taoist {
    color: #333333;
    font-size: 0.85rem;
}

.titleLeft {
    font-size: 0.8rem;
    line-height: 1.8rem;
}

.content {
    /* height: 2.4rem; */
    border-bottom: 1px dashed #dfdfdf;
    line-height: 2.2rem;
    margin-left: 0.64rem;
    margin-right: 0.64rem;
    /* padding-left: 0.64rem;
    padding-right: 0.64rem; */
}
.title{
    width:15rem;
    text-align: left;
    overflow: hidden;
}
.time {
    color: #999999;
    font-size: 0.6rem;
    text-align: right;
}

.pageBar {
    margin-top: 3.5rem;
    text-align: center;
}
</style>